module.exports = __webpack_public_path__ + "static/media/tiago.aa42cd9f.jpg";